import React, { useState, useEffect } from "react"
import CtaBtn from "../UIElements/CtaBtn"
import { Link } from "gatsby";
import * as amplitude from '@amplitude/analytics-browser';

const isBrowser = typeof window !== "undefined"

export default function GDPRCheck() {

    const [ showBanner, setShowBanner ] = useState(false);

    if (isBrowser) {
      // amplitude.setOptOut(true);
      window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }

        gtag('consent', 'default', {
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'wait_for_update': 500,
        });
    }    

    const acceptTracking = () => {
      amplitude.setOptOut(false);
        if (isBrowser) {
              function gtag() { window.dataLayer.push(arguments); }
              gtag('consent', 'update', {
                  ad_user_data: 'granted',
                  ad_personalization: 'granted',
                  ad_storage: 'granted',
                  analytics_storage: 'granted'
              });
            }
        localStorage.setItem("amp-consentGranted", "true");
        localStorage.setItem("ga-consentGranted", "true");
        setShowBanner(false);
    }

    const rejectTracking = () => {
      amplitude.setOptOut(true);
      setShowBanner(false);
    }

    useEffect(() => {
        const ampConsent = localStorage.getItem("amp-consentGranted");
        const gaConsent = localStorage.getItem("ga-consentGranted");
        setShowBanner(ampConsent === null || gaConsent === null);
        if (ampConsent === "true" || gaConsent === "true") {
            acceptTracking();
        }
    }, [])

    if (showBanner) {
        return (
            <div className="pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6 z-50">
              <div className="pointer-events-auto ml-auto max-w-xl rounded-xl bg-white p-6 shadow-lg ring-1 ring-gray-900/10">
                <p className="text-sm leading-6 text-gray-900">
                  We know the importance of data especially when it comes to personal data and so we want to be transparent with our use of cookies on our site.
                  We use cookies to monitor the speed and effectiveness of our site, study which content you love the most and if you provide your contact details we may send you more information on topics that interest you.
                </p>
                <p className="text-sm leading-6 text-gray-900">
                <Link to="/cookies" className="font-semibold text-orange-600">
                    You can find more detailed information here
                  </Link>
                </p>
                <div className="mt-4 md:flex items-center gap-x-5">
                  <CtaBtn label={"Accept"} colour={'orange'} className={'mb-5 md:mb-0'} onClick={() => {
                      console.log("Accept");
                      acceptTracking();
                  }} />
                  <CtaBtn label={"Reject"} colour={'orange'} secondary={true} onClick={() => {
                      console.log("Reject");
                      rejectTracking();
                  }} />

                </div>
              </div>
            </div>
          )
    }

    return null;
  }